// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"553f1f25","842":"0a55238a"}[chunkId] + ".chunk.js";
};